(function () {
    'use strict';

    let module = angular.module('imApp');

    module.component('deviationType', {
        templateUrl: 'views/components/views/deviationType/deviationType.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'deviationTypeService', function ($stateParams, stateService, modalService, translateService, deviationTypeService) {
            let vm = this;
            let deviationTypeKeyno = $stateParams.deviationtype_keyno;

            let translations = {
            	error: '',
            	ok: ''
            };

            vm.model = {
                edit: {},
                lockedSave: false
            };

            translateService.translateBatch(translations).then(function (data) {
            	angular.forEach(translations, function (_, key) {
            		if (angular.isDefined(data[key])) {
            			translations[key] = data[key];
            		}
            	});
            });

            let loadEdit = function () {
                deviationTypeService.getDeviationType({ deviationtype_keyno: deviationTypeKeyno }).then(function (result) {
                    angular.copy(result[0], vm.model.edit);
                });
            };
            
            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                deviationTypeService.saveObj(vm.model.edit).then(function (response) {
                    if (response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            };

            vm.$onInit = function () {
                loadEdit();
            };
        }]
    });
})();
